import { render, staticRenderFns } from "./SharedOptionQuestionInput.vue?vue&type=template&id=0818f779&scoped=true"
import script from "./SharedOptionQuestionInput.vue?vue&type=script&lang=js"
export * from "./SharedOptionQuestionInput.vue?vue&type=script&lang=js"
import style0 from "./SharedOptionQuestionInput.vue?vue&type=style&index=0&id=0818f779&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0818f779",
  null
  
)

export default component.exports